<template>
    <div>

        <div v-if="editAutorizacao && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <i style="font-size: 15px; text-align: center; display: block;">
            Este recurso permite gerar códigos de autorizações para que os usuários do sistema consigam 
            realizar matrículas de alunos que não passaram nos critérios de validações 
            (como idade mínima ou máxima, falta de documentação etc.);
        </i>

        <div style="padding-top: 20px; max-width: 700px; margin: auto;" v-if="!codigo">
            <el-form @submit.native.prevent="onSubmitAutorizacao" v-if="!editAutorizacao || dados.id" :model="dados" ref="dados" label-position="top">
                <div v-if="!editAutorizacao || dados.id">

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="18" :md="18">
                            <el-form-item label="Nome do Aluno" prop="ocorrencia" :rules="[$requiredBlur]" key="ocorrencia">
                                <el-input v-model="dados.ocorrencia" maxlength="191" v-on:blur="formatData('ocorrencia')"></el-input>
                            </el-form-item>
                        </el-col>                        
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item class="u-text-left" style="margin-top: 23px">
                                <el-button type="primary" id="btn-autorizacao" native-type="submit">GERAR CÓDIGO</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </div>

        <div v-if="codigo" style="text-align: center; margin: 40px 0px;">
            <span class="cod-autorizacao">CÓDIGO DE AUTORIZAÇÃO: {{ codigo }}</span>
            <br>
            <i style="font-size: 15px; text-align: center; display: block; margin-top: 30px;">
                Repasse o código de autorização ao usuário que está realizando a matrícula.<br>
                O código só poderá ser utilizado uma única vez na liberação da matrícula do aluno (a) {{ this.dados.ocorrencia }}.
            </i>
            <el-row :gutter="10">                    
                <el-col :xs="24" :sm="24" :md="24">
                    <el-button style="margin-top: 20px;" type="primary" @click="$router.back()">VOLTAR</el-button>
                </el-col>
            </el-row>
        </div>
        

    </div>
</template>
<script>

export default {
    props: ['paramId'],
    data: () => ({
        editAutorizacao: false,
        alert: false,
        dados: {
            ocorrencia: ''
        },
        codigo: ''

    }),
    mounted () {

    },
    methods:{
        getAutorizacaoById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/autorizacao/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
 
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitAutorizacao(){

            document.getElementById("btn-autorizacao").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
 
                window.eventBus.$emit('loading', true);              
  
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/autorizacao/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                
                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                    this.codigo = response.data.cod;

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        resetFormAutorizacao(){
          
            this.dados = { id: '', ocorrencia: '' };
            this.$refs.dados.clearValidate();
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';            

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getAutorizacaoById(value);
                    this.editAutorizacao = true;
                } 
            }
        },
    }
}
</script>
